module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "alert alert-info"
  }, [_vm._v("\n      " + _vm._s(_vm.message) + " "), (_vm.username) ? _c('strong', [_vm._v("[" + _vm._s(_vm.username) + "]")]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-666b7762"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/util/Message.vue
// module id = 1456
// module chunks = 1